import React from 'react'

import Button from '../components/Button'
import { LeftRight, Parallax } from '../components/animations'

import plane from '../images/tools/plane.svg'
import hacksaw from '../images/tools/hacksaw.svg'
import axe from '../images/tools/axe.svg'

import pic1 from '../images/pic1.jpg'
import pic2 from '../images/pic2.jpg'
import pic8 from '../images/pic8.jpg'

function Showroom() {
  return (
    <>
      <section className="w-full md:flex items-center mb-12 max-w-screen-lg mx-auto relative">
        <div style={{ left: '-16rem', bottom: 0 }} className="absolute w-56 h-56 -z-10">
          <Parallax>
            <LeftRight>
              <img src={plane} alt="plane" />
            </LeftRight>
          </Parallax>
        </div>
        <div className="md:w-3/5 p-8">
          <h2 className="text-4xl md:text-5xl font-display text-black">Interni</h2>
          <p className="text-md md:text-lg lg:text-xl text-black">
            Nostrud irure ullamco Lorem enim labore officia velit aute amet nostrud minim cillum do consequat. Ad ullamco officia mollit proident quis. Exercitation labore ipsum occaecat eu incididunt fugiat voluptate id. Quis nulla labore laboris sit exercitation magna fugiat. Laboris ullamco magna non reprehenderit.
          </p>
          <Button onPress="/interni" alternate classes="py-2 mt-4">Scopri altri &rarr;</Button>
        </div>
        <div className="md:w-2/5">
          <img className="object-cover w-full h-72 md:rounded-l-lg lg:rounded-lg shadow-lg" alt="scale in legno" src={pic1} />
        </div>
        <div style={{ left: 30, bottom: -10 }} className="md:hidden absolute w-56 h-56 -z-10">
          <Parallax>
            <img src={axe} alt="axe" />
          </Parallax>
        </div>
      </section>
      <section className="w-full md:flex-row-reverse md:flex items-center mb-12 max-w-screen-lg mx-auto">
        <div className="md:w-3/5 p-8 text-right">
          <h2 className="text-4xl md:text-5xl font-display text-black">Arredo</h2>
          <p className="text-md md:text-lg lg:text-xl text-black">
            Nostrud irure ullamco Lorem enim labore officia velit aute amet nostrud minim cillum do consequat. Ad ullamco officia mollit proident quis. Exercitation labore ipsum occaecat eu incididunt fugiat voluptate id. Quis nulla labore laboris sit exercitation magna fugiat. Laboris ullamco magna non reprehenderit.
          </p>
          <Button onPress="/arredo" alternate classes="py-2 mt-4">Scopri altri &rarr;</Button>
        </div>
        <div className="md:w-2/5">
          <img className="object-cover w-full h-72 md:rounded-r-lg lg:rounded-lg shadow-lg" alt="mobile restauranto in legno" src={pic2} />
        </div>
      </section>
      <section className="w-full md:flex items-center mb-12 max-w-screen-lg mx-auto relative">
        <div className="md:w-3/5 p-8">
          <h2 className="text-4xl md:text-5xl font-display text-black">Blockhouse</h2>
          <p className="text-md md:text-lg lg:text-xl text-black">
            Nostrud irure ullamco Lorem enim labore officia velit aute amet nostrud minim cillum do consequat. Ad ullamco officia mollit proident quis. Exercitation labore ipsum occaecat eu incididunt fugiat voluptate id. Quis nulla labore laboris sit exercitation magna fugiat. Laboris ullamco magna non reprehenderit.
          </p>
        </div>
        <div className="md:w-2/5">
          <img className="object-cover w-full h-72 md:rounded-l-lg lg:rounded-lg shadow-lg" alt="desc" src="https://images.unsplash.com/photo-1557236516-29504c9fe789?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80" />
        </div>
        <div style={{ left: 30, bottom: 160 }} className="md:hidden absolute w-56 h-56 -z-10">
          <Parallax>
            <img src={hacksaw} alt="hacksaw" />
          </Parallax>
        </div>
      </section>
      <section className="w-full md:flex-row-reverse md:flex items-center mb-12 max-w-screen-lg mx-auto relative">
        <div style={{ right: '-20rem' }} className="absolute w-72 h-72 -z-10">
          <Parallax>
            <LeftRight>
              <img src={hacksaw} alt="hacksaw" />
            </LeftRight>
          </Parallax>
        </div>
        <div className="md:w-3/5 p-8 text-right">
          <h2 className="text-4xl md:text-5xl font-display text-black">Linfa toys</h2>
          <p className="text-md md:text-lg lg:text-xl text-black">
            Nostrud irure ullamco Lorem enim labore officia velit aute amet nostrud minim cillum do consequat. Ad ullamco officia mollit proident quis. Exercitation labore ipsum occaecat eu incididunt fugiat voluptate id. Quis nulla labore laboris sit exercitation magna fugiat. Laboris ullamco magna non reprehenderit.
          </p>
          <Button onPress="/linfa-toys" alternate classes="py-2 mt-4">Scopri altri &rarr;</Button>
        </div>
        <div className="md:w-2/5">
          <img className="object-cover w-full h-72 md:rounded-r-lg lg:rounded-lg shadow-lg" alt="mobile restauranto in legno" src={pic8} />
        </div>
      </section>
    </>
  )
}

export default Showroom